import { ModalRef } from 'constants/WorkingModePathwaysConstants'

import { AgendaTableModal } from './modals/AgendaTableModal'
import { BandedWorkstreamDetailModal } from './modals/BandedWorkstreamDetailModal'
import { SprintWorkstreamDetailModal } from './modals/SprintWorkstreamDetailModal'
import { WorkstreamAgendaModal } from './modals/WorkstreamAgendaModal'
import { WorkstreamDetailModal } from './modals/WorkstreamDetailModal'

interface PathwayModalHostProps {
  activeModal: ModalRef | null
  onClose: () => void
}

export const PathwayModalHost = ({ activeModal, onClose }: PathwayModalHostProps) => {
  if (!activeModal) return null

  switch (activeModal.template) {
    case 'workstream-agenda':
      return <WorkstreamAgendaModal isOpen id={activeModal.id} onClose={onClose} />
    case 'agenda-table':
      return <AgendaTableModal isOpen id={activeModal.id} onClose={onClose} />
    case 'workstream-detail':
      return activeModal.id === 'async-sprint-detail' ? (
        <SprintWorkstreamDetailModal isOpen id={activeModal.id} onClose={onClose} />
      ) : (
        <WorkstreamDetailModal isOpen id={activeModal.id} onClose={onClose} />
      )
    case 'banded-workstream-detail':
      return <BandedWorkstreamDetailModal isOpen id={activeModal.id} onClose={onClose} />
    default:
      return null
  }
}
